import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useLocale } from "@/lib/locale";

const STORAGE_KEY = "os_cookie_consent";

export default function CookieBanner() {
    const { t } = useLocale();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        try {
            const prior = localStorage.getItem(STORAGE_KEY);
            if (!prior) setVisible(true);
        } catch {
            setVisible(true);
        }
    }, []);

    const record = async (level) => {
        const payload = {
            level,
            accepted_at: new Date().toISOString(),
        };
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
        } catch {}
        setVisible(false);
        try {
            await api.post("/legal/cookies", { level });
        } catch {
            // Non-blocking: UI choice is already persisted locally.
        }
    };

    if (!visible) return null;

    return (
        <div
            role="dialog"
            aria-live="polite"
            aria-label="Cookie consent"
            data-testid="cookie-banner"
            className="fixed bottom-0 inset-x-0 z-40 animate-fade-in-slow"
        >
            <div className="mx-auto max-w-3xl m-4 md:m-6">
                <div className="bg-ink-surfaceUp/95 backdrop-blur border border-ink-border rounded-sm p-5 md:p-6 shadow-[0_12px_48px_-16px_rgba(0,0,0,0.7)] flex flex-col md:flex-row gap-4 md:items-center">
                    <p className="text-ink-textMid text-sm md:text-[0.95rem] leading-relaxed md:flex-1">
                        {t("cookie.text")}{" "}
                        <Link to="/legal" className="text-ink-gold underline underline-offset-4 hover:text-ink-goldHi">
                            {t("footer.legal")}
                        </Link>.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-2 md:gap-3 shrink-0">
                        <button
                            type="button"
                            onClick={() => record("essential")}
                            className="px-4 py-2.5 text-xs tracking-widest uppercase border border-ink-border text-ink-textMid hover:text-ink-textHigh hover:border-ink-textMid transition-colors rounded-sm"
                            data-testid="cookie-accept-essential"
                        >
                            {t("cookie.essential")}
                        </button>
                        <button
                            type="button"
                            onClick={() => record("all")}
                            className="px-5 py-2.5 text-xs tracking-widest uppercase bg-ink-gold hover:bg-ink-goldHi text-ink-deep font-semibold transition-colors rounded-sm"
                            data-testid="cookie-accept-all"
                        >
                            {t("cookie.all")}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
